import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Mic, ExternalLink, Clock, Calendar } from 'lucide-react';
const APPLE_EMBED = 'https://embed.podcasts.apple.com/gb/podcast/will-the-%2465bln-unilever-mccormick-food-deal-create-value/id1665680837?i=1000774175673';
const APPLE_LINK = 'https://podcasts.apple.com/gb/podcast/will-the-%2465bln-unilever-mccormick-food-deal-create-value/id1665680837?i=1000774175673';
const COVER_ART = 'https://cdn.magicpatterns.com/uploads/6wjHdezjBHwsSX1Zdoajif/gres.png';
export function Publications() {
  return <section id="media" className="relative py-24 overflow-hidden bg-navy text-offwhite" data-id="element-175">
      {/* Atmospheric artwork background */}
      <div aria-hidden="true" className="absolute inset-0 bg-cover bg-center scale-110 blur-md opacity-60" style={{
      backgroundImage: `url(${COVER_ART})`
    }} data-id="element-176"></div>
      <div aria-hidden="true" className="absolute inset-0 bg-navy/80" data-id="element-177"></div>

      <div className="max-w-6xl mx-auto px-6 md:px-12 relative z-10" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-179">
          <div className="mb-16" data-id="element-180">
            <h2 className="font-serif text-3xl md:text-4xl mb-6" data-id="element-181">
              Media &amp; Publications
            </h2>
            <div className="w-16 h-px bg-gold" data-id="element-182"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start" data-id="element-183">
            {/* Cover art */}
            <div className="lg:col-span-5" data-id="element-184">
              <motion.img initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.7
            }} src={COVER_ART} alt="The Mergers & Acquisitions Podcast with Guus Greve" loading="lazy" decoding="async" className="w-full h-auto rounded-2xl shadow-2xl ring-1 ring-white/10" data-id="element-185" />
            </div>

            {/* Details + player */}
            <div className="lg:col-span-7" data-id="element-186">
              <div className="flex items-center space-x-3 mb-5" data-id="element-187">
                <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-gold" data-id="element-188">
                  <Mic size={14} data-id="element-189" />
                  Podcast Appearance
                </span>
              </div>

              <h3 className="font-serif text-2xl md:text-3xl leading-snug mb-4" data-id="element-190">
                Will the $65bln Unilever–McCormick Food Deal Create Value?
              </h3>

              <p className="text-gray-300 text-sm font-medium mb-6" data-id="element-191">
                The Mergers &amp; Acquisitions Podcast · Season 3, Episode 4
              </p>

              <p className="text-gray-400 leading-relaxed mb-8" data-id="element-192">
                Host Guus Greve is joined by his former Shell colleague and
                current Non-Executive Director, Richard Oblath, to discuss and
                analyse the recently announced Unilever–McCormick deal —
                applying lessons from prior episodes to examine whether the
                transaction will ultimately create shareholder value.
              </p>

              <div className="flex flex-wrap gap-6 mb-8 text-sm text-gray-400" data-id="element-193">
                <span className="inline-flex items-center gap-2" data-id="element-194">
                  <Calendar size={16} className="text-gold" data-id="element-195" />
                  28 June 2026
                </span>
                <span className="inline-flex items-center gap-2" data-id="element-196">
                  <Clock size={16} className="text-gold" data-id="element-197" />
                  27 minutes
                </span>
              </div>

              <a href={APPLE_LINK} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 border border-gray-500 text-offwhite font-medium hover:border-gold hover:text-gold transition-colors duration-300 mb-8" data-id="element-198">
                Listen on Apple Podcasts
                <ExternalLink size={16} data-id="element-199" />
              </a>

              <div className="bg-white/5 p-4 backdrop-blur-sm border border-white/10 rounded-xl" data-id="element-200">
                <iframe title="Richard Oblath on The Mergers & Acquisitions Podcast — Unilever-McCormick deal" allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write" frameBorder="0" loading="lazy" height="175" style={{
                width: '100%',
                overflow: 'hidden',
                borderRadius: '10px'
              }} sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation" src={APPLE_EMBED} data-id="element-201" />
                <p className="text-xs text-gray-400 mt-3 text-center" data-id="element-202">
                  Press play to listen without leaving the page.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}